import { BaseService } from './base';
import { DiscountModel } from '../models/discountModel';

export class DiscountModelService extends BaseService<DiscountModel> {
  override model = DiscountModel;
  override modelName = 'discountModel';
  override modelLabel = 'Discount Model';
}
